import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ProfileContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#E7EFF5',
  minHeight: 'calc(100vh - 64px)',
  width: '100%',
  maxWidth: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

export const TabPanel = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '0 0 4px 4px',
  boxShadow: theme.shadows[1],
  marginTop: 0,
  border: '1px solid #CDD6D9',
  borderTop: 'none',
}));

export const ContentPanel = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  padding: theme.spacing(3),
  borderRadius: '0 0 4px 4px',
  boxShadow: 'none',
}));

export const SuggestChangesButton = styled(Box)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  color: '#000000',
  padding: theme.spacing(0.5, 1.5),
  borderRadius: theme.shape.borderRadius,
  fontSize: '0.75rem',
  fontWeight: 600,
  display: 'inline-block',
  marginBottom: theme.spacing(2),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
})); 